import styled from "styled-components";

export const Wrapper = styled.div`
  > *:not(:last-child) {
    margin-right: 1rem;
  }
`;
